import React from 'react';
import { useNavigate } from 'react-router-dom';
import { GoVerified } from "react-icons/go";

import { Logo, Button } from '../components';
import { Container, InputContainer, RegisterMessage, Imgs } from '../styles';

function RegisterSuccess() { 
  const navigate = useNavigate();

  const handleBackToLogin = () => {
    navigate('/');
  };

  return (
    <Container>
      <InputContainer>
        <Logo src={Imgs.logo} alt="Blue House" width="200px" height="auto"/>
        <RegisterMessage>Seu cadastro foi realizado com sucesso!</RegisterMessage>
        <GoVerified fontSize={80} color='green' style={{marginBottom: '50px'}}/>
        <Button onClick={handleBackToLogin}  title="RETORNAR AO LOGIN"></Button>
      </InputContainer>
    </Container>
  );
}

export default RegisterSuccess;
